import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/mobile_concept.png")